'use client'
import { buttonVariants } from "@/components/fun-ui/Button"
import { cn } from "@/lib/utils"

interface HeroButtonProps {
  cookieHasNickname: boolean
  onClick: () => void
}

export default function HeroButton({ cookieHasNickname, onClick }: HeroButtonProps) {
  return (
    <button
      onClick={onClick}
      className={cn(
        buttonVariants({ variant: 'default' }),
        "py-0 rounded-full cursor-pointer",
        "h-[52px] text-lg w-[170px]",
      )}
    >
      {cookieHasNickname ? '进入 Findin' : '免费试用'}
    </button>
  )
}